<template>
  <div>
    <el-card>
      <div style="font-size: 16px; margin-bottom: 20px">{{ goodsItemIdData.name }}</div>
      <el-row :span="24">
        <el-col :span="24" v-if="addWay != 1">
          <div v-if="goodsItemIdData.type == '专栏'">
            <el-button type="primary" @click="addGoodsList('录播')" icon="el-icon-plus">添加录播</el-button>
            <el-button type="primary" @click="addGoodsList('题库')" icon="el-icon-plus">添加题库</el-button>
            <el-button type="primary" @click="addGoodsList('实训')" icon="el-icon-plus">添加实训</el-button>
<!--            <el-button type="primary" @click="addGoodsList('直播')" icon="el-icon-plus">添加直播</el-button>-->
          </div>
          <div v-else>
            <el-button type="primary" @click="addGoodsVideo" v-if="
              goodsItemIdData.type == '录播' ||
              goodsItemIdData.type == '套餐' ||
              goodsItemIdData.type == '面授'
            " icon="el-icon-plus">添加录播</el-button>
<!--            <el-button type="primary" @click="addLiveVideo" v-if="-->
<!--              goodsItemIdData.type == '直播' ||-->
<!--              goodsItemIdData.type == '套餐' ||-->
<!--              goodsItemIdData.type == '面授'-->
<!--            " icon="el-icon-plus">添加直播</el-button>-->
            <el-button v-if="
              goodsItemIdData.type == '题库' ||
              goodsItemIdData.type == '套餐' ||
              goodsItemIdData.type == '面授'
            " type="primary" @click="addGoodsChapter('题库')" icon="el-icon-plus">添加题库</el-button>
            <el-button v-if="
              goodsItemIdData.type == '题库' ||
              goodsItemIdData.type == '套餐' ||
              goodsItemIdData.type == '面授'
            " type="primary" @click="addGoodsExam()" icon="el-icon-plus">添加考试</el-button>
            <el-button v-if="goodsItemIdData.type == '实训'" type="primary" @click="addGoodsActualOperation" icon="el-icon-plus">添加实训</el-button>
            <!-- <el-button
            v-if="goodsItemIdData.type=='面授'"
            type="primary"
            @click="addGoodsChapter('面授')"
            icon="el-icon-plus"
          >添加面授</el-button> -->
          </div>
        </el-col>
      </el-row>
      <div class="block" v-if="goodsItemIdData.type == '专栏'">
        <el-table :data="page.rows" style="width: 100%; margin-bottom: 20px; margin-top: 20px">
          <el-table-column type="expand">
            <template slot-scope="{row}">
              <el-table :data="row.goodsItemList" style="width: 100%; margin-bottom: 20px; margin-top: 20px" row-key="id" border default-expand-all :tree-props="{
                children: 'children',
                hasChildren: 'hasChildren',
              }">
                <el-table-column label="所属课程">
                  <template slot-scope="{row}">
                    {{ row.courseName }}
                  </template>
                </el-table-column>
                <el-table-column label="名称">
                  <template slot-scope="{row}">
                    {{ row.name }}
                  </template>
                </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="{row}">
                    <span>{{ row.type }}</span>
                    <div v-if="row.powerList" style="display: inline">
                      <span class="line"></span>
                      <el-popover trigger="click" v-model="row.isPrpover">
                        <el-checkbox-group v-model="checkList">
                          <el-checkbox v-for="(item, index) in powerList" :key="index" :label="item.power">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                        <el-button size="mini" type="primary" class="type-btn" @click="sunmitType(row)">提交</el-button>
                        <span slot="reference" @click="rangeCli(row)">范围<i class="el-icon-arrow-down el-icon--right"></i></span>
                      </el-popover>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="{row}">
                    <span v-if="row.type == '录播'" style="margin-left: 30px" class="mainColor" @click="opConmon(row, 1)">查看</span>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="商品名">
            <template slot-scope="{row}">
              {{ addWay == 1 ? row.goodsInfoCenter.name : row.goodsInfo.name }}
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="{row}">
              {{ addWay == 1 ? row.goodsInfoCenter.type : row.goodsInfo.type }}
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="addWay == 2">
            <template slot-scope="{row}">
              <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" @confirm="unbundleGoodsItem(row.id)" @onCancel="deleteCancel" title="确定解绑吗？">
                <el-button type="text" slot="reference">解绑</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <div style="width: 100%" class="draggable-tableaaa">
          <div style class="draggable-table">
            <div class="answer bor" style="width: 20%">所属课程</div>
            <div class="answer bor" style="width: 40%">名称</div>
            <div class="answer bor" style="width: 20%">类型</div>
            <div class="delete bor" style="width: 20%">操作</div>
          </div>
          <draggable v-if="page.rows.length" v-model="page.rows" @update="datadragEnd" :options="{ animation: 500 }">
            <!-- <transition-group> -->
            <div v-for="(element, index) in page.rows" :key="index" class="drag-item">
              <div class="draggable-table">
                <el-tooltip :open-delay="500" class="item" effect="dark" :content="element.courseName">
                  <div style="width: 20%" class="answer">
                    {{ element.courseName || "暂无" }}
                  </div>
                </el-tooltip>
                <el-tooltip :open-delay="500" class="item" effect="dark" :content="element.name">
                  <div style="width: 40%" class="answer">{{ element.name || "暂无" }}</div>
                </el-tooltip>
                <div style="width: 20%" class="answer">
                  <span>{{ element.type || "暂无" }}</span>
                  <div v-if="element.powerList" style="display: inline">
                    <span class="line" v-if="$route.query.addWay == 2"></span>
                    <el-popover trigger="click" v-model="element.isPrpover">
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox v-for="(item, index) in powerList" :key="index" :label="item.power">{{ item.name }}</el-checkbox>
                      </el-checkbox-group>
                      <el-button size="mini" type="primary" class="type-btn" @click="sunmitType(element)">提交</el-button>
                      <span slot="reference" v-if="$route.query.addWay == 2" @click="rangeCli(element)">范围<i class="el-icon-arrow-down el-icon--right"></i></span>
                    </el-popover>
                  </div>
                </div>
                <div style="width: 20%" class="delete">
                  <el-popconfirm v-if="addWay != 1" title="确定改操作？" @confirm="unbundleGoodsItem(element.id)">
                    <el-button type="text" slot="reference">解绑</el-button>
                  </el-popconfirm>
                  <span v-if="element.type == '录播'" style="margin-left: 30px" class="mainColor" @click="opConmon(element, 1)">查看</span>
                  <span @click="openComment(element)" class="comment mainColor">评论 <i class="hasComment">{{ element.commentNum || 0 }}</i></span>
                  <!--openCommentDialog-->
                </div>
              </div>
            </div>
          </draggable>
          <div v-else style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          ">
            暂无数据
          </div>
        </div>
        <el-pagination background layout="sizes,total, prev, pager, next" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="commentVisible" width="800px" left>
      <div class="comment-title" slot="title">评论管理 <span :key="commentTotal">共({{ commentTotal }})条</span></div>
      <div class="comment-main">
        <div class="comment-list">
          <div :class="item.state == -1 ? 'comment-item grayscale' : 'comment-item'" v-for="item in commentList" :key="item.id">
            <div class="left-right">
              <div class="comment-left">
                <img :src="item.student.headPic" alt="">
              </div>
              <div class="comment-center">
                <div class="comment-info">
                  <span class="comment-person">{{ item.student.name }}</span>
                  <div class="comment-time">{{ item.createTime }}</div>
                </div>
                <span class="comment-content">{{ item.content }}</span>
              </div>
            </div>
            <div class="comment-right">
              <el-switch @change="commentControl(item)" :disabled="item.state == -1" v-model="item.state == 1 ? true : false"></el-switch>
            </div>
          </div>
        </div>
      </div>
      <el-pagination background layout="prev, pager, next" :page-size="10" :total="commentTotal" @current-change="handleCurrentChange" :current-page.sync="currentPage">
      </el-pagination>
    </el-dialog>
    <el-dialog title="添加录播" :visible.sync="addVideoVisible" width="800px" left>
      <el-form ref="searchForm" :model="videoSearchForm" :label-width="formLabelWidths">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input v-model="videoSearchForm.name" placeholder="请输入视频课程名称" auto-complete="off"></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="videocoursePageList" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="videocoursePage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属课程"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="视频课程名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="videocoursePage.total" :page-size="videocoursePage.pageSize" :current-page="videocoursePage.pageNumber" @size-change="videoSizeChange" @current-change="videoCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addVideoVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加直播" :visible.sync="addLiveVisible" width="800px" left>
      <el-form ref="searchForm" :model="liveSearchForm" :label-width="formLabelWidths">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input clearable v-model="liveSearchForm.name" placeholder="请输入直播名称" auto-complete="off"></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="livePageList" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="livePage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="liveSelectionChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="courseName" label="所属课程"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="直播名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="publisher" label="主讲老师"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="courseCount" label="课时数"></el-table-column> -->
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="livePage.total" :page-size="livePage.pageSize" :current-page="livePage.pageNumber" @size-change="liveSizeChange" @current-change="liveCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addLiveVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>
    <el-dialog title="添加试卷" :visible.sync="addSubjectVisible" width="800px" left>
      <el-form ref="searchForm" :model="subjectForm" :label-width="formLabelWidth">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目">
              <el-cascader :show-all-levels="false" ref="tree" @change="subjectChange" :options="subjectTreeList" :props="subjectTreeProps" collapse-tags clearable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="pageListExamType" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="subjectPage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="subjectSelectionChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="所属课程">
          <template slot-scope="row">{{ row.row.ppname != null ? row.row.ppname + "-" : ""
          }}{{ row.row.pname != null ? row.row.pname + "-" : ""
}}{{ row.row.name != null ? row.row.name : "" }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="examType" label="试卷类型"></el-table-column>
      </el-table>
      <el-pagination background layout="sizes,total, prev, pager, next" style="margin-top: 20px; text-align: right" :page-sizes="[10, 50, 100, 200]" :total="subjectPage.total" :page-size="subjectPage.pageSize" :current-page="subjectPage.pageNumber" @size-change="subjectSizeChange" @current-change="subjectCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addSubjectVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加考试" :visible.sync="addExamVisible" width="800px" left>
      <el-form ref="searchForm" :model="examSearchForm" :label-width="formLabelWidth">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-form-item label="所属科目">
              <el-cascader :show-all-levels="false" ref="tree" @change="examSubjectChange" :options="subjectTreeList" :props="subjectTreeProp" clearable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="pageListExam" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="examPage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="examSelectionChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="所属课程">
          <template slot-scope="scope">{{
              scope.row.subjectCourse ? scope.row.subjectCourse.name || "" : ""
          }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="sequence" label="考试期数">
          <template slot-scope="row">第{{ row.row.sequence }}期</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="sequence" label="试卷">
          <template slot-scope="row">{{
              row.row.examSettingRelationList.length > 0
                ? row.row.examSettingRelationList[0].exam.name
                : ""
          }}</template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="sizes,total, prev, pager, next" style="margin-top: 20px; text-align: right" :page-sizes="[10, 50, 100, 200]" :total="examPage.total" :page-size="examPage.pageSize" :current-page="examPage.pageNumber" @size-change="examSizeChange" @current-change="examCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addExamVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="预览视频" :visible.sync="videoDialog" @close="closeDialog" width="900px" :append-to-body="true" :close-on-click-modal="false">
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
    </el-dialog>
    <el-dialog :title="'添加' + chapterListType" :visible.sync="addChapterVisible" width="800px" left>
      <el-table ref="multipleTable" :data="chapterPage.rows" tooltip-effect="dark" style="width: 100%" border @selection-change="chapterSelectionChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="所属课程">
          <template slot-scope="row">{{ row.row.ppname != null ? row.row.ppname + "-" : ""
          }}{{ row.row.pname != null ? row.row.pname + "-" : ""
}}{{ row.row.name != null ? row.row.name : "" }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="课程名称"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="chapterPage.total" :page-size="chapterPage.pageSize" :current-page="chapterPage.pageNumber" @size-change="chapterSizeChange" @current-change="chapterCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addChapterVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加实训" :visible.sync="addActualOperationVisible" width="800px" left>
      <el-table ref="multipleTable" :data="actualOperationPage.rows" tooltip-effect="dark" style="margin-top: -30px; width: 100%" border @selection-change="actualOperationChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cid" label="cid"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cname" label="课程名称"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="actualOperationPage.total" :page-size="actualOperationPage.pageSize" :current-page="actualOperationPage.pageNumber" @size-change="actualOperationSizeChange" @current-change="actualOperationCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addActualOperationVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定视频" :visible.sync="bindVisible" width="80%" left>
      <el-table v-show="showState == 1" :data="page1.rows" style="width: 100%; margin-bottom: 20px; margin-top: 20px">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.videoInfoList" style="width: 100%; margin-bottom: 20px; margin-top: 20px" border>
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column prop="videoCourseName" label="具体课程" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="name" label="视频名称" :show-overflow-tooltip="true"></el-table-column>

              <el-table-column prop="tryUse" label="试看" align="center" width="100">
                <template slot-scope="row">
                  <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
                  <span v-else class="mainColor">否</span>
                </template>
              </el-table-column>
              <el-table-column prop="playCount" label="次数" align="center" width="100"></el-table-column>
              <el-table-column align="center" prop="url" label="播放" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <i class="el-icon-caret-right" style="font-size: 20px; color: #409eff" @click="
  playerOptions.sources[0].src = scope.row.url;
videoDialog = true;
                  "></i>
                </template>
              </el-table-column>
              <el-table-column prop="duration" align="center" width="100" label="时长"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="分组名称" prop="name"> </el-table-column>
      </el-table>
      <el-table v-show="showState == 0" ref="multipleTables" :data="page1.rows" tooltip-effect="dark" style="width: 100%" v-loading="bindVisibleLoading" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="sort" label="排序" width="55"></el-table-column>
        <el-table-column prop="videoCourseName" label="具体课程" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="视频名称" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="tryUse" label="试看" align="center" width="100">
          <template slot-scope="row">
            <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
            <span v-else class="mainColor">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="playCount" label="次数" align="center" width="100"></el-table-column>
        <el-table-column align="center" prop="url" label="播放" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <i class="el-icon-caret-right" style="font-size: 20px; color: #409eff" @click="
  playerOptions.sources[0].src = scope.row.url;
videoDialog = true;
            "></i>
          </template>
        </el-table-column>
        <el-table-column prop="duration" align="center" width="100" label="时长"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page1.total" :page-sizes="[10, 50, 100, 200]" :small="true" :page-size="page1.pageSize" :current-page="page1.pageNumber" @size-change="sizeChange1" @current-change="currentChange1"></el-pagination>
    </el-dialog>

    <!-- 专栏的弹窗 -->
    <el-dialog :title="`添加${goodsType}`" :visible.sync="addGoodsListVisible" width="900px" left>
      <el-form ref="searchGoodsForm" :model="goodsSearchForm" label-width="formLabelWidths">
        <el-row>
          <el-col :sm="8" :md="8" :lg="8">
            <el-input v-model="goodsSearchForm.name" placeholder="请输入商品名" auto-complete="off"></el-input>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="goodsPageList" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="goodsPage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selecteGoodsItemChange">
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="商品名"></el-table-column>
        <el-table-column show-overflow-tooltip prop="type" label="类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目"></el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsItemCount" label="内容"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" style="margin-top: 20px; text-align: right" :total="goodsPage.total" :page-size="goodsPage.pageSize" :current-page="goodsPage.pageNumber" @size-change="goodsSizeChange" @current-change="goodsCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addGoodsListVisible = false">取 消</el-button>
        <el-button @click="addGoodsBatchList" type="primary">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import conmon from "../videoCourse/conmon";
import liveComponent from './liveComponent'
export default {
  data () {
    return {
      addGoodsListVisible: false,
      goodsSearchForm: {},
      goodsPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      goodsType: '',
      treeLoading: false,
      treeList: [],

      addWay: 0,
      powerList: [],
      checkList: [],
      videoDialog: false,
      bindVisible: false,
      bindVisibleLoading: false,
      comMonid: "",
      typeName: "",

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      pList: [], //二级列表
      ppList: [], //一级列表
      videoCourseIds: [],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
      },
      page1: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      livePage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      subjectPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      examPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      chapterPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        level: 2,
        sortName: "",
        sortOrder: "",
      },
      actualOperationPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      actualOperationForm: {},
      addVideoVisible: false,
      addExamVisible: false,
      addLiveVisible: false,
      addSubjectVisible: false,
      addChapterVisible: false,
      addActualOperationVisible: false,
      searchForm: {},
      videoSearchForm: {},
      liveSearchForm: {},
      subjectForm: {},
      examSearchForm: {},
      chapterForm: {
        ppid: "",
        pid: "",
      },
      formLabelWidth: "80px",
      formLabelWidths: "100px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/goodsItem/upload`,
      fileList: [],
      loading: true,
      goodsItemIdData: [],
      type: "",
      chapterListType: "",
      commentVisible: false, // 评论管理弹窗是否开启
      allowSeen: true, // 是否允许学员端展示评论
      currentPage: 1, // 分页 页数
      commentTotal: 0, // 分页 总数
      commentList: [],//评论列表
      videoCourseId: '', // 获取评论的参数
      showState: 0
    };
  },
  components: {
    draggable,
    conmon,
    liveComponent
  },
  mounted () {
    this.addWay = parseInt(this.$route.query.addWay);
    console.log(this.addWay, "addWayaddWayaddWayaddWay", this.$route);
    this.getGoodsItemData();
  },
  methods: {
    // 评论管理弹窗
    openComment (item) {
      this.commentVisible = !this.commentVisible
      this.currentPage = 1
      this.videoCourseId = item.objectId
      this.getCommentList();
    },
    commentControl (item) {
      console.log(32)
      this.api.student.changeCommentStatus({
        id: item.id,
        state: item.state == 1 ? 0 : 1
      }).then(() => {
        this.getCommentList()
      })
    },
    // 获取评论列表
    getCommentList () {
      this.api.student.getCommentList({
        videoCourseId: this.videoCourseId,
        pageNumber: this.currentPage,
        pageSize: 10
      }).then(res => {
        if (res.data) {
          this.commentList = res.data.records
          this.commentTotal = res.data.total
        }
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getCommentList();
    },
    // 范围弹出窗赋初值
    rangeCli (form) {
      this.checkList = [];
      this.powerList = JSON.parse(JSON.stringify(form.powerList));
      form.powerList.forEach((item) => {
        if (item.hasPower) this.checkList.push(item.power);
      });
    },
    // 范围更改提交
    sunmitType (element) {
      let val = 0;
      this.checkList.forEach((item) => (val = val | +item));
      let obj = JSON.parse(JSON.stringify(element));
      obj.power = val;
      this.api.videoInfo.updateGoodsItem(obj).then((res) => {
        if (res.code == 200) {
          element.isPrpover = false;
          this.$message.success(res.message);
        } else this.$message.error(res.message);
        this.pageList();
      });
    },
    pageList () {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.goodsItemIdData.copyGoodsInfoId;
      this.searchForm.addWay = this.addWay
      this.searchForm.type = this.goodsItemIdData.type == '直播' ? '直播' : undefined
      this.api.goodsItem
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.rows.forEach((item) => {
            if (item.powerList) item.isPrpover = false;
          });
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    opConmon (row, sty) {
      this.bindVisible = true;
      this.comMonid = sty == 1 ? row.objectId : row.id;
      this.typeName = row.type;
      console.log(row)
      this.pageList1(row.showState);
    },
    pageList1 (rstate) {
      this.bindVisibleLoading = true
      this.page1.videoCourseId = this.comMonid;
      this.page1.showState = rstate || '';
      this.api.videoInfo.pageList(this.page1).then((result) => {
        if (result.success) {
          this.showState = result.data.showState
          if (result.data.showState) {
            this.page1.rows = result.data.subjectVideoList;
          }
          this.page1.rows = result.data.pageList.records;
          this.page1.total = result.data.total;
        } else {
          this.$message.error(result.message);
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => this.bindVisibleLoading = false);
    },
    closeDialog () {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    deleteCancel () {
      // alert(0);
    },
    datadragEnd (evt) {
      let arr = [];
      this.page.rows.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // console.log(this.colors);
    },

    // 专栏 start ===================================================================================
    addGoodsList (type) {
      this.goodsSearchForm = {}
      this.type = '专栏'
      this.goodsType = type
      let params = {
        type,
        pageSize: this.goodsPage.pageSize,
        pageNumber: this.goodsPage.pageNumber,
      }
      console.log(params, 34);
      this.getGoodsInfo(params)
      this.addGoodsListVisible = true;
    },
    // 获取录播课程
    getGoodsInfo (params) {
      this.api.goodsInfo.getGoodsInfoByType(params).then(res => {
        if (res.success) {
          let { data } = res
          this.goodsPage.rows = data.records
          this.goodsPage.total = data.total
          console.log(this.goodsPage.rows);
        }
      })
    },
    // 专栏弹窗中的search方法
    goodsPageList () {
      let name = this.goodsSearchForm.name
      let params = {
        name,
        type: this.goodsType,
        pageSize: this.goodsPage.pageSize,
        pageNumber: this.goodsPage.pageNumber,
      }
      this.getGoodsInfo(params)
    },
    // 专栏弹窗中的添加方法
    addGoodsBatchList () {
      console.log(this.ids);
      this.api.goodsItem
        .addGoodsItemBatch(this.ids, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.addGoodsListVisible = false;
            this.$message.success(result.message);
            this.pageList();
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    // 分页 -- 每页条数
    goodsSizeChange (pageSize) {
      console.log(pageSize);
      this.goodsPage.pageSize = pageSize
      this.addGoodsList(this.goodsType);
    },
    // 分页 -- 页数
    goodsCurrentChange (pageNumber) {
      console.log(pageNumber, this.goodsType);
      this.goodsPage.pageNumber = pageNumber;
      this.addGoodsList(this.goodsType);
    },
    // 批量选择
    selecteGoodsItemChange (val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },

    // 专栏 end =====================================================================================

    addGoodsVideo () {
      this.type = "录播课程";
      this.getSubjectTreeList();
      this.videocoursePageList();
      this.addVideoVisible = true;
    },
    addLiveVideo () {
      this.type = "直播课程";
      this.getSubjectTreeList();
      this.livePageList();
      this.addLiveVisible = true;
    },
    addGoodsSubject () {
      this.type = "试卷";
      this.getSubjectTreeList();
      this.pageListExamType();
      this.addSubjectVisible = true;
    },
    addGoodsChapter (chapterListType) {
      // this.type = "章节";
      this.chapterListType = chapterListType;
      this.type = chapterListType + "课程";
      this.getTypeLit();
      this.pageListChapter();
      this.addChapterVisible = true;
    },
    addGoodsExam () {
      this.getSubjectTreeList();
      this.pageListExam();
      this.addExamVisible = true;
    },
    addGoodsActualOperation () {
      this.type = "实训课程";
      this.pageListActualOperation();
      this.addActualOperationVisible = true;
    },
    videoSubjectChange (val) {
      this.videoSearchForm.courseIds = [];
      val.forEach((item) => {
        this.videoSearchForm.courseIds.push(item[2]);
      });
    },
    examSubjectChange (val) {
      if (val) {
        let len = val.length;
        this.examSearchForm.courseId = val[len - 1];
      } else {
        this.examSearchForm.courseId = "";
      }
    },
    subjectChange (val) {
      this.subjectForm.ids = [];
      val.forEach((item) => {
        this.subjectForm.ids.push(item[2]);
      });
    },
    videocoursePageList () {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.videoSearchForm.sortName = this.videocoursePage.sortName;
      this.videoSearchForm.sortOrder = this.videocoursePage.sortOrder;
      this.videoSearchForm.subjectId = this.$route.query.subjectId;
      this.videoSearchForm.type =
        this.goodsItemIdData.type == "直播" || this.goodsItemIdData.type == "录播"
          ? this.goodsItemIdData.type
          : "";

      this.api.videoCourse
        .pageList(this.videoSearchForm)
        .then((result) => {
          this.videocoursePage.rows = result.data.records;
          this.videocoursePage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    livePageList () {
      this.liveSearchForm.subjectId = this.$route.query.subjectId;
      this.liveSearchForm.pageSize = this.livePage.pageSize;
      this.liveSearchForm.pageNumber = this.livePage.pageNumber;
      this.liveSearchForm.sortName = this.livePage.sortName;
      this.liveSearchForm.sortOrder = this.livePage.sortOrder;
      this.liveSearchForm.type = "1";
      this.api.liveRoom
        .pagelistForRecord(this.liveSearchForm)
        .then((result) => {
          this.livePage.rows = result.data.records;
          this.livePage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListExamType () {
      this.subjectForm.pageSize = this.subjectPage.pageSize;
      this.subjectForm.pageNumber = this.subjectPage.pageNumber;
      this.subjectForm.sortName = this.subjectPage.sortName;
      this.subjectForm.sortOrder = this.subjectPage.sortOrder;
      this.api.goodsItem
        .pageListExamType(this.subjectForm)
        .then((result) => {
          this.subjectPage.rows = result.data.records;
          this.subjectPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    pageListExam () {
      this.examSearchForm.pageSize = this.examPage.pageSize;
      this.examSearchForm.pageNumber = this.examPage.pageNumber;
      this.api.examSetting
        .pageList(this.examSearchForm)
        .then((result) => {
          this.examPage.rows = result.data.records;
          this.examPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListChapter () {
      this.chapterForm.pageSize = this.chapterPage.pageSize;
      this.chapterForm.pageNumber = this.chapterPage.pageNumber;
      this.chapterForm.level = this.chapterPage.level;
      this.chapterForm.sortName = this.chapterPage.sortName;
      this.chapterForm.sortOrder = this.chapterPage.sortOrder;
      this.chapterForm.pid = this.$route.query.subjectId;

      this.api.subjectCourse
        .getPageList(this.chapterForm)
        .then((result) => {
          this.chapterPage.rows = result.data.records;
          this.chapterPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListActualOperation () {
      this.actualOperationForm.pageSize = this.actualOperationPage.pageSize;
      this.actualOperationForm.pageNumber = this.actualOperationPage.pageNumber;
      this.actualOperationForm.sortName = this.actualOperationPage.sortName;
      this.actualOperationForm.sortOrder = this.actualOperationPage.sortOrder;
      this.api.goodsItem
        .actualOperationPageList(this.actualOperationForm)
        .then((result) => {
          this.actualOperationPage.rows = result.data.records;
          this.actualOperationPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addGoodsItemBatch () {
      // console.log(JSON.stringify(this.ids))
      this.api.goodsItem
        .addGoodsItemBatch(this.ids, {
          goodsId: this.$route.query.goodsId,
          addWay: this.$route.query.addWay,
        })
        .then((result) => {
          if (result.success) {
            this.addVideoVisible = false;
            this.addExamVisible = false;
            this.addSubjectVisible = false;
            this.addChapterVisible = false;
            this.addLiveVisible = false;
            this.addActualOperationVisible = false;
            this.pageList();
            this.$message.success(result.message);
            this.ids = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    unbundleGoodsItem (vId) {
      console.log("dsadsdasdas");
      this.api.goodsItem.deleteGoodsItem([{ id: vId }]).then((result) => {
        this.pageList();
        this.$message.success("解绑成功");
      });
    },
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取一级列表
    getTypeLit () {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0,
        })
        .then((result) => {
          this.ppList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取二级列表
    choosePPid () {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: this.chapterForm.ppid,
        })
        .then((result) => {
          this.pList = result.data;
          this.chapterForm.pid = "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGoodsItemData () {
      this.api.goodsInfo
        .getGoodsInfo({ id: this.$route.query.updatePageGoodsItem })
        .then((result) => {
          this.goodsItemIdData = result.data;
          this.pageList();
        });
      console.log(this.goodsItemIdData);
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    sizeChange1 (pageSize) {
      this.page1.pageSize = pageSize;
      this.pageList1();
    },
    currentChange1 (pageNumber) {
      this.page1.pageNumber = pageNumber;
      this.pageList1();
    },

    videoSizeChange (pageSize) {
      this.videocoursePage.pageSize = pageSize;
      this.videocoursePageList();
    },
    videoCurrentChange (pageNumber) {
      this.videocoursePage.pageNumber = pageNumber;
      this.videocoursePageList();
    },
    liveSizeChange (pageSize) {
      this.livePage.pageSize = pageSize;
      this.livePageList();
    },
    liveCurrentChange (pageNumber) {
      this.livePage.pageNumber = pageNumber;
      this.livePageList();
    },

    examSizeChange (pageSize) {
      this.examPage.pageSize = pageSize;
      this.pageListExam();
    },
    examCurrentChange (pageNumber) {
      this.examPage.pageNumber = pageNumber;
      this.pageListExam();
    },
    subjectSizeChange (pageSize) {
      this.subjectPage.pageSize = pageSize;
      this.pageListExamType();
    },
    subjectCurrentChange (pageNumber) {
      this.subjectPage.pageNumber = pageNumber;
      this.pageListExamType();
    },
    chapterSizeChange (pageSize) {
      this.chapterPage.pageSize = pageSize;
      this.pageListChapter();
    },
    chapterCurrentChange (pageNumber) {
      this.chapterPage.pageNumber = pageNumber;
      this.pageListChapter();
    },
    actualOperationSizeChange (pageSize) {
      this.actualOperationPage.pageSize = pageSize;
      this.pageListActualOperation();
    },
    actualOperationCurrentChange (pageNumber) {
      this.actualOperationPage.pageNumber = pageNumber;
      this.pageListActualOperation();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: this.type,
      }));
    },
    examSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: "考试",
      }));
    },
    liveSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: this.type,
      }));
    },
    subjectSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: this.type,
        examType: e.examType,
      }));
    },
    chapterSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: this.type,
      }));
    },
    actualOperationChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.copyGoodsInfoId,
        type: this.type,
      }));
    },
  },
};
</script>
<style lang="less" scoped>
.type-btn {
  transform: translateX(-50%);
  margin-left: 50%;
  margin-top: 15px;
}

.line {
  display: inline-block;
  margin: 0 5px;
  border-left: 1px solid #a39e9e75;
  height: 10px;
}

.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }

  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }

    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        display: none !important;
      }

      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;

        img {
          display: none !important;
        }
      }
    }

    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .state {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      white-space: nowrap;
    }

    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .comment {
        position: relative;
        margin-left: 10px;
      }

      .hasComment {
        position: absolute;
        top: -4px;
        right: -22px;
        width: 25px;
        height: 12px;
        font-style: normal;
        line-height: 10px;
        text-align: center;
        color: #fcf8fa;
        background-color: #e44d44;
        border-radius: 15px;
        font-size: 12px;
      }
    }
  }
}

.comment-title {}

.comment-main {
  .comment-list {
    .comment-item {
      margin-bottom: 20px;
      padding: 10px 40px;
      display: flex;
      align-items: center;
      box-shadow: 1px 1px 8px rgba(0, 0, 0, .1);
      border-radius: 5px;

      .left-right {
        flex: 7;
        display: flex;
        align-items: center;

        .comment-left {
          flex: 0.8;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }

        .comment-center {
          flex: 7;

          .comment-info {
            margin-bottom: 10px;
            display: flex;
            justify-content: space-between;

            .comment-person {}

            .comment-time {}
          }

          .comment-content {}

        }
      }

      .comment-right {
        flex: 1;
        margin-left: 10px;
      }
    }
  }
}

.grayscale {
  color: #C0C4CC;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/goodsItem.vue